import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const Root = styled.div.withConfig({
  displayName: "DropdownTitle__Root",
  componentId: "sc-ht8tsu-0"
})(["", " text-transform:uppercase;color:var(--neutral-text-low-emphasis);font:var(--text-xs-bold);padding:var(--size-spacing-02) var(--size-spacing-04);"], ScopedCssBaseline);
const DropdownTitle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref
  }), children);
});
DropdownTitle.displayName = 'DropdownTitle';
DropdownTitle.Style = Root;
process.env.NODE_ENV !== "production" ? DropdownTitle.propTypes = {
  /**
   * Sets the children element
   */
  children: PropTypes.node.isRequired
} : void 0;
export default DropdownTitle;